// no itx for this file
import type KnxProductInfo from "./KnxProductInfo";
import { cleanDecode, safeJSONDecode } from "../utils/CommonUtils";

/** Decode one metadata record in place (legacy API). */
export function getDecodedMetadata(metadataOriginal: KnxProductInfo, language?: string): KnxProductInfo {
  let metadata = metadataOriginal;
  metadata.ManufacturerName = cleanDecode(metadata?.ManufacturerName || "");

  if (typeof metadata.ProductNames != "object") {
    //
    // if we load from indexDB / Cache, the conversion is allready done
    //
    metadata.ProductNames = safeJSONDecode(metadata?.ProductNames || "{}") || {};
  }

  metadata.DefaultProductName = cleanDecode(metadata?.DefaultProductName || "");
  metadata.ProductName = language
    ? metadata.ProductNames[language] || metadata.DefaultProductName
    : metadata.DefaultProductName;

  if (typeof metadata.ProductDescriptions != "object") {
    metadata.ProductDescriptions = safeJSONDecode(metadata?.ProductDescriptions || "{}") || {};
  }
  if (language) {
    metadata.ProductDescription = metadata.ProductDescriptions?.[language] || metadata.ProductDescription || "";
  }

  if (typeof metadata.Applications != "object") {
    metadata.Applications = safeJSONDecode(metadata?.Applications || "{}") || {};
  }

  if (metadata?.Variants && typeof metadata?.Variants == "string") {
    metadata.Variants = safeJSONDecode(metadata.Variants || "[]") || [];
  }

  metadata.DefaultApplication = cleanDecode(metadata?.DefaultApplication || "");
  metadata.Application = language
    ? metadata.Applications[language] || metadata.DefaultApplication
    : metadata.DefaultApplication;

  metadata.Type = cleanDecode(metadata?.Type || "");
  return metadata;
}

/** Decode catalog records for a product list without modifying the source records.
 * Variants remain attached to their product; they are not flattened.
 */
export function decodeKnxProductInfos(
  metadata: readonly KnxProductInfo[],
  language?: string,
): KnxProductInfo[] {
  return metadata.map(product => getDecodedMetadata(structuredClone(product), language));
}
